export default "__VITE_ASSET___I0boaIt__"